import { toast } from '@london-life/ui/feedback/game-toaster';

// every game note goes out as a snackbar, through here
export const notify = (text: string, options?: { id?: string; duration?: number }) => void toast(text, options);
export const notifyProblem = (text: string) => void toast.error(text, { duration: 5000 });
